import '@ant-design/v5-patch-for-react-19';
import '@thisisdmg/tirecloud-patterns/index.css';
import '@thisisdmg/tirecloud-patterns/v2/index.css';
import initCss from '@thisisdmg/tirecloud-patterns/v2/init.css?raw';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/he';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import durationPlugin from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import { createElement as el, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'reflect-metadata';
import './app.css';
import App from './App.tsx';
import setupSentry from '@/features/sentry/functions/setupSentry.ts';
import initI18n from '@/i18n.ts';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(durationPlugin);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const initStyleSheet = document.createElement('style');
initStyleSheet.setAttribute('data-rc-order', 'prependQueue');
initStyleSheet.setAttribute('data-rc-priority', '-6666');
initStyleSheet.innerHTML = initCss;
document.head.prepend(initStyleSheet);

const root = createRoot(document.getElementById('root')!);
initI18n().then((t) => {
  setupSentry(t);
  root.render(el(StrictMode, null, el(App)));
});
